module.exports = __webpack_public_path__ + "img/pl.0d2a2cc6.svg";